import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-vertical",
  "use": "arrow-vertical-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-vertical\">\r\n<path d=\"M13 5.99L13 11L11 11L11 5.99L8 5.99L12 2L16 5.99L13 5.99Z\" />\r\n<path d=\"M13 19.01L13 14L11 14L11 19.01L8 19.01L12 23L16 19.01L13 19.01Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol